<template>
  <div
    ref="footer"
    :class="[
      `footer`, `pr`,
      `footer--${$route.name}`,
      {
        'footer--sidebar' : $route.meta.sidebar,
      }
    ]"
    :style="{ 'background-color': org.custom_color3 == null ? '': org.custom_color3, }"
  >
    <div class="group">
      
      <div class="footer__logolinks">
        <router-link
          :to="{ name: `home` }"
          :class="[
            'footer__logoimg',
          ]"
        >
          <img 
            src="../assets/images/brand/footer-logo.svg" 
            alt="footer_logo"
          >
        </router-link>
        <ul class="list list--footer mt-footer">
          <li class="list__item1" v-for="link in footer.links" :key="link.url">
            <router-link :to="{'name': link.url}" class="list c-white tdn link">{{ link.label }}</router-link>
          </li>
        </ul>
        
      </div>
      <p class="p small c-white pat2 mt0 p--no-width">{{ footer.copy }}</p>
    </div>
  </div>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex';


export default {
  name: 'ui-footer-legal',

  props: {
    footer: Object,
    center: Boolean,
  },

  computed: {
    ...mapGetters('app', ['org']),
  },

};

</script>



// WEBPACK FOOTER //
// Footer.vue?30a3916e